// ==========================================================================
// booking module
// ==========================================================================
/* jshint esnext: true */
import {APP_NAME, $body, $document} from '../utils/environment';
import AbstractModule from './AbstractModule';
import {EVENT as CALENDAR_EVENT} from './Calendar';
import {EVENT as CART_FORM_EVENT} from './CartForm';

const MODULE_NAME = 'BookingCart';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    CLICK:       `click.${EVENT_NAMESPACE}`,
    INPUT:       `input.${EVENT_NAMESPACE}`,
    CHANGE:      `change.${EVENT_NAMESPACE}`,
    SUBMIT:      `submit.${EVENT_NAMESPACE}`,
    UPDATE_CART: `updateCart.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.isTransmitting = false;
        this.isProcessingPromo = false;
        this.xhr = null;
        this.selectedDeparture = null;

        this.$controls = this.$el.find('.js-booking-controls');
        this.$promoControl = this.$el.find('.js-booking-promo-control');
        this.$tourSelect = this.$el.find('.js-tour-select');
        this.$numSeats = this.$el.find('.js-num-seats');
        this.$dateInput = this.$el.find('.js-input-date');
        this.$departureInput = this.$el.find('.js-input-departure');
        this.$passengers = this.$el.find('.js-passenger');
        this.$passengersName = this.$el.find('.js-passenger-name');
        this.$priceEquation = this.$el.find('.js-price-equation');
        this.$totalPrice = this.$el.find('.js-total-price');
        this.$checkout = this.$el.find('.js-checkout');
        this.$promoName = this.$el.find('.js-booking-promo-name');

        this.form = options.form || null;
        this.tour = options.tour || null;
        this.departure = options.departure || null;
        this.tourName = options.name || null;
        this.singlePrice = null;
        this.numPassengers = null;
        this.promo = null;
        this.validCode = null;

        if (this.form) {
            this.$form = $(this.form);
        }

        this.totalPrice = 0;
    }

    // ==========================================================================
    // Initialisation
    // ==========================================================================

    init() {

        // Init events listeners
        this.events();

        this.calculatePrice();
        this.updateNumPassenger(this.$numSeats.val());
        this.setSelectedDeparture(this.departure);

        // First update of the calendar using the default data provided by the form.
        this.updateCalendar();
    }

    calculatePrice() {
        let price = this.singlePrice;
        let seats = this.$numSeats.val();
        let totalPrice = price * seats;
        let fromPrice = this.totalPrice;
        let promo = this.promo;

        if (promo !== null) {
            totalPrice = eval(totalPrice + promo.operator + promo.discount);
            totalPrice = (Math.round(totalPrice * 100) / 100).toFixed(2);
        }

        this.totalPrice = totalPrice;

        let output = seats + ' &times; £' + price;

        this.$priceEquation.hide().html(output).fadeIn(200);

        // NO COUNT UP VERSION
        // setTimeout(() => this.$totalPrice.hide().html('£' + totalPrice).fadeIn(200), 200);
        var easingFn = function (t, b, c, d) {
            var ts = (t /= d) * t;
            var tc = ts * t;
            return b + c * (tc + -3 * ts + 3 * t);
        };

        let isFloat = parseInt(totalPrice) !== totalPrice;

        let count = new CountUp(
            this.$totalPrice.get(0),
            parseFloat(fromPrice),
            parseFloat(totalPrice),
            isFloat ? 2 : 0, // number of decimal
            1, // animation duration
        {
            useEasing:   true,
            easingFn:    easingFn,
            useGrouping: true,
            separator:   ',',
            decimal:     '.',
            prefix:      '£'
        });
        count.start();

        this.updateTotalPriceMobile(totalPrice);
    }

    updateTotalPriceMobile(totalPrice) {
        let totalPriceMobileElement = document.querySelector('.js-total-price-mobile');
        if(totalPriceMobileElement) {
            totalPriceMobileElement.textContent = '£' + totalPrice;
        }
    }

    updateNumPassenger(numPassenger) {
        this.numPassengers = numPassenger;
        // this.processPromoCode();
        this.$passengers.each((index, ele) => {
                (numPassenger > index)
                    ? $(ele).slideDown()
                    : $(ele).slideUp();
            }
        )
    }

    updateCalendar() {

        if (this.xhr && this.isTransmitting) {
            this.xhr.abort();
            this.toggleCalendarLoading();
        }

        // Tour id
        let tour = this.tour;

        // Number of seats needed
        let seatsNumber = this.$numSeats.val();

        let data = {
            num_seats: seatsNumber
        };

        this.toggleCalendarLoading();

        this.xhr = $.get(
            'api/v1/tour/' + tour + '/departures',
            data,
            (response) => {
                let events = response.data.departures;

                $document.triggerHandler({
                    type:   `setEvents.Englishbus.Calendar`,
                    events: events
                });

                // keep selected date if able to.
                if (this.selectedDeparture) {
                    let datetime = this.selectedDeparture.datetime;
                    for (let event in events) {
                        if (events[event].datetime === datetime && events[event].availability !== 'booked') {
                            // Communicate the selectedDate with calendar
                            $document.triggerHandler({
                                type:     `setSelectedDate.Englishbus.Calendar`,
                                datetime: datetime
                            });
                            this.calculatePrice();

                            this.updateCartForm();
                            this.toggleCalendarLoading();
                            return;
                        }
                    }
                }
                // Select the first available departure.
                for (let event in events) {
                    if (events[event].availability !== 'booked') {
                        this.setDefaultDeparture(events[event]);
                        this.toggleCalendarLoading();
                        return;
                    }
                }

                this.setDefaultDeparture();
                this.toggleCalendarLoading();
            });
    }

    setDefaultDeparture(departure) {
        this.selectedDeparture = null;
        if (departure !== undefined && departure.availability !== 'booked') {
            this.processDeparture(departure);

            // Communicate the selectedDate with calendar
            $document.triggerHandler({
                type:     `setSelectedDate.Englishbus.Calendar`,
                datetime: departure.datetime
            });
        } else {
            this.setCheckout(false);
            this.$promoControl.attr('disabled', true).parent().slideUp();
            this.removePromoCode();
            this.$departureInput.val(null);
            this.singlePrice = 0;
            this.calculatePrice();
            this.$dateInput.val('No departures for the moment.').addClass('-empty');
        }
    }

    // When a date is selected from the calendar
    setSelectedDeparture(departure) {
        if (departure !== undefined) {
            this.processDeparture(departure);
        }
    }

    processDeparture(departure) {
        this.departure = departure;
        this.setCheckout(true);
        this.$promoControl.attr('disabled', false).parent().slideDown();
        this.$departureInput.val(departure.id);
        this.$dateInput.val(departure.date.long).removeClass('-empty');
        this.singlePrice = departure.price;
        this.calculatePrice();

        this.selectedDeparture = departure;

        // Making sure the promo code is still valid.
        this.processPromoCode();
    }

    updateCartForm() {
        $document.triggerHandler({
            type:          EVENT.UPDATE_CART,
            departure:     this.departure,
            numPassengers: this.numPassengers,
            totalPrice:    this.totalPrice,
            code:          this.validCode,
            tour: {
                id: this.tour,
                name: this.tourName
            }
        });
    }

    updateCartPassenger(passenger) {
        this.$passengersName.each((ident, ele) => {
            if ($(ele).data('ident') === passenger.ident) {
                $(ele).html(passenger.value);
            }
        });
    }

    processPromoCode() {
        let $input = this.$promoControl;
        let promoCode = $input.val();

        if (!promoCode) {
            return;
        }

        if (!this.promoLoader) {
            this.promoLoader = this.circleLoader(
                $input.siblings().find('.js-circle-loader')
            );
        }

        let loader = this.promoLoader;

        if (this.xhr && this.isProcessingPromo) {
            this.xhr.abort();
            this.toggleCartLoading();
        }

        loader.load();
        this.toggleCartLoading();

        let data = {
            tour:           this.tour,
            date:           this.selectedDeparture.datetime,
            num_passengers: this.numPassengers
        };

        this.xhr = $.get(
            'validate/code/' + promoCode,
            data,
            (response) => {
                let isValid = response.data.type !== undefined;

                if (!isValid) {
                    this.validCode = null;
                    loader.fail();
                    this.removePromoCode();
                    this.toggleCartLoading();
                    return;
                }

                this.validCode = promoCode;
                let codeType = response.data.type;

                switch (codeType) {
                    case 'promo':
                        this.addPromoCode(response.data);
                        break;
                    case 'agency':
                        this.addAgencyCode(response.data);
                        break;
                }

                loader.success();
                this.toggleCartLoading();
            });
    }

    circleLoader($ele) {
        return {
            loader:        $ele,
            loaderSuccess: '',
            loaderFail:    '',
            init: function () {
                this.loaderSuccess = this.loader.find('.js-circle-loader-success');
                this.loaderFail = this.loader.find('.js-circle-loader-fail');
                return this;
            },
            load: function () {
                this.loader.fadeIn();
                this.loader.toggleClass('-load-complete', false);
                this.loader.toggleClass('-load-fail', false);
                this.loaderSuccess.toggle(false);
                this.loaderFail.toggle(false);
                return this;
            },
            success: function () {
                this.loader.toggleClass('-load-complete', true);
                this.loaderSuccess.toggle(true);
                return this;
            },
            fail: function () {
                this.loader.toggleClass('-load-fail', true);
                this.loaderFail.toggle(true);
                return this;
            }
        }.init();
    }

    removePromoCode() {
        this.promo = null;
        this.calculatePrice();
        this.updateCartForm();
        this.$promoName.slideUp();
        this.setCheckoutMode('checkout');
    }

    addPromoCode(codeData) {
        this.promo = codeData;
        this.calculatePrice();
        this.updateCartForm();
        this.$promoName.html(codeData.name + ' applied').slideDown();
        this.setCheckoutMode('checkout');
    }

    addAgencyCode(codeData) {
        this.promo = codeData;

        this.calculatePrice();
        this.updateCartForm();
        this.$promoName.html(codeData.name + ' logged in').slideDown();
        this.setCheckoutMode('pre-order');
    }

    setCheckoutMode(mode) {
        switch (mode) {
            case 'pre-order':
                this.$checkout.each((index, ele) => {
                    if ($(ele).hasClass('-pre-order')) {
                        setTimeout(() => {
                            $(ele).fadeIn();
                        }, 400);
                    } else {
                        $(ele).fadeOut();
                    }
                });
                break;
            case 'checkout':
                this.$checkout.each((index, ele) => {
                    if ($(ele).hasClass('-pre-order')) {
                        $(ele).fadeOut();
                    } else {
                        setTimeout(() => {
                            $(ele).fadeIn();
                        }, 400);
                    }
                });
                break;
        }
    }

    /**
     * Simple method for toggling animation states
     *
     * @return void
     */
    toggleCalendarLoading() {
        this.isTransmitting = !this.isTransmitting;

        if (this.isTransmitting) {
            this.$el.addClass('is-loading');
        } else {
            setTimeout(() => {
                this.$el.removeClass('is-loading');
            }, 500);
        }
    }

    toggleCartLoading() {
        this.isProcessingPromo = !this.isProcessingPromo;

        this.setCheckout(!this.isProcessingPromo);
    }

    /**
     * Trigger cart form submission
     *
     * @param event
     */
    onCheckout(event) {
        this.$form.submit();
    }

    setCheckout(state) {
        $body.toggleClass('is-checkout-disabled', !state);
        this.$checkout.attr('disabled', !state);
    }

    throttle(ident, callback, timer = 300) {
        if (!this.throttler) {
            this.throttler = [];
        }

        if (this.throttler[ident]) {
            clearTimeout(this.throttler[ident]);
        }

        this.throttler[ident] = setTimeout(() => {
            callback()
        }, timer)
    }

// ==========================================================================
// Event Listeners
// ==========================================================================

    events() {
        this.$numSeats.on(EVENT.CHANGE, (e) => {
            this.updateNumPassenger($(e.currentTarget).val());
        });
        this.$controls.on(EVENT.CHANGE, () => this.updateCalendar());
        this.$promoControl.on(EVENT.INPUT, () => this.throttle('promo', this.processPromoCode.bind(this)));
        this.$checkout.on(EVENT.CLICK, (e) => this.onCheckout(e));

        // external listeners
        $document.on(CALENDAR_EVENT.SELECT_EVENT, (options) => this.setSelectedDeparture(options.departure));
        $document.on(CART_FORM_EVENT.PASSENGER_UPDATE, (options) => this.updateCartPassenger(options));
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
